import React, { useEffect, useState } from "react";
import withRouter from "../../custom/withRouter";
import Pagination from "react-js-pagination";
import { connect } from "react-redux";
import downArrow from "../../../assets/svg/downarrow.svg";
import upArrow from "../../../assets/svg/uparrow.svg";
import AddIcon from "../../../assets/svg/addIcon.svg";
import RemoveIcon from "../../../assets/svg/removeIcon.svg";
// import CommonSearch from "../..//pages/search/Search";
import arrowright from "../../../assets/svg/arrow-right.svg";
import arrowleft from "../../../assets/svg/arrow-left.svg";
import axios from "axios";
import { PulseLoader } from "react-spinners";
import API from "../../../helpers/endpointService";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import "react-toastify/dist/ReactToastify.css";
import EditIcon from "../../../assets/svg/editIcon.svg";
import CategoryIcon from "../../../assets/svg/categorymaxIcon.svg";
import DownArrowIcon from "../../../assets/svg/downarrow.svg";
import ButtonSubmitIcon from "../../../assets/svg/submitbuttonIcon.svg";
import SubCategoryIcon from "../../../assets/svg/smallcategory.svg";
import UpArrowIcon from "../../../assets/svg/uparrow.svg";
import LeftArrowIcon from "../../../assets/svg/LeftArrow.svg";
import RightArrowIcon from "../../../assets/svg/RightArrow.svg";
import CrossIcon from "../../../assets/svg/crossIcon.svg";
import WarningIcon from "../../../assets/svg/warningIcon.svg";
import Filter from "../../../assets/svg/filter.svg";
import search from "../../../assets/svg/search.svg";
import ReactPaginate from "react-paginate";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import $ from "jquery";
import { logoutFunction } from "../../custom/commonFunction";
import moment from "moment";

const paginglist = [
  { label: "5", value: 5 },
  { label: "10", value: 10 },
  { label: "20", value: 20 },
  { label: "50", value: 50 },
];
const paginglistDefault = [{ label: "20", value: 20 }];
var closeNewSearch = false;

class Category1 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: "asc",
      sortBy: "category1Name",
      height: window.innerHeight,
      isCategory1Failed: false,
      isCategory1Loader: false,
      isMobile: false,
      isRadioMobile: false,
      isCancelMobile: false,
      isCategory1AddHide: false,
      isCategory1EditHide: false,
      isCategory1DeleteHide: false,
      iswebMobile: false,
      categoryEmpty: false,
      isSmallMobile: false,
      category1List: undefined,
      category1ArryList: [],
      userId: 0,
      totalCount: 0,
      currentPage: 1,
      perPage: 20,
      addcategoryValue: {
        categoryName: "",
        isSubCategory: false,
        categoryId: 0,
        parentCategoryId: 0,
      },
      editcategoryValue: {
        categoryName: "",
        isSubCategory: false,
        categoryId: 0,
        parentCategoryId: 0,
      },
      isView: false,
      isFormValid: true,
      searchCategory1List: [],
      searchInputCategory: "",
    };
  }

  componentDidMount() {
    let _this = this;
    this.GetCategory1List();
    let user = localStorage.getItem("UserId");
    this.state.userId = user;
    this.setState({});
    const intervals = setInterval(() => {
      this.resize();
    }, 10);
  }

  GetCategory1List = (page) => {
    const { currentPage, perPage } = this.state;
    let order = this.state.order === "asc" ? true : false;
    let apiUrl = `${API.GET_CATAGORY2}?category1Id=0&sortBy=${this.state.sortBy}&isSortAscending=${order}`;
    this.setState({ isCategory1Loader: true, isCategory1Failed: false });
    axios({
      method: "POST",
      url: apiUrl,
      data: {
        pageNumber: parseInt(currentPage),
        pagesize: parseInt(perPage),
      },
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.category1List = res.data.values;
          this.state.totalCount = res.data.totalCount;
          this.state.isCategory1Loader = false;
          this.state.isCategory1Failed = false;
          this.setState({});
          // this.setState({ isCategory1Loader: false, isCategory1Failed: false });
        }
      })
      .catch((error) => {
        this.setState({ isCategory1Loader: false, isCategory1Failed: false });
        logoutFunction(error?.response?.status);
      });
  };

  GetDropdownCategory1 = () => {
    let apiUrl = `${API.GET_CATAGORY_DROPDOWN}?type=category1&isLedger=false`;
    axios({
      method: "GET",
      url: apiUrl,
    }).then((res) => {
      if (res.status === 200) {
        this.state.searchCategory1List = res.data?.map((res) => {
          return {
            value: res.categoryId,
            label: res.categoryName,
          };
        });
        this.setState({});
      }
    });
  };

  resize = () => {
    if (window.innerWidth < 850) {
      this.state.isMobile = true;
    } else {
      this.state.isMobile = false;
    }
    if (window.innerWidth < 450) {
      this.state.isRadioMobile = true;
    } else {
      this.state.isRadioMobile = false;
    }
    if (window.innerWidth < 400) {
      this.state.iswebMobile = true;
    } else {
      this.state.iswebMobile = true;
    }
    if (window.innerWidth < 300) {
      this.state.isSmallMobile = true;
    } else {
      this.state.isSmallMobile = false;
    }
    if (window.innerWidth < 315) {
      this.state.isCancelMobile = true;
    } else {
      this.state.isCancelMobile = false;
    }
    this.state.height = window.innerHeight;
    this.setState({});
  };

  find = (e) => {
    this.state.perPage = e.value;
    this.setState({ isCategory1Loader: true, isCategory1Failed: false });
    const selectedPage = 1;
    this.state.currentPage = selectedPage;
    this.setState({}, () => {
      this.GetCategory1List();
    });
  };
  handlePageChange = (pageNumber) => {
    this.state.currentPage = pageNumber;
    this.setState({}, () => {
      //console.log(this.state.currentPage);
    });
    this.GetCategory1List();
  };

  handlecategoryInputchange(e, field, type) {
    if (type === "Add") {
      this.state.addcategoryValue[field] = e.target.value;
      this.state.categoryEmpty = false;
      this.setState({});
    } else if (type === "Edit") {
      this.state.editcategoryValue[field] = e.target.value;
      this.setState({});
    }
  }
  OpenAddcategory1 = () => {
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("addCategory1Screen")
    );
    myOffcanvas.show();
    this.state.category1ArryList = [];
    this.setState({});
    $("body").addClass("scrollhide");
  };
  handleCheckbox = (x) => {
    const { category1ArryList } = this.state;
    if (category1ArryList?.length == 0) {
      category1ArryList.push(x);
    } else {
      if (
        category1ArryList &&
        category1ArryList?.filter((i) => i == x)?.length == 1
      ) {
        category1ArryList?.map((i, ind) =>
          i == x ? category1ArryList.splice(ind, 1) : ""
        );
      } else {
        category1ArryList.push(x);
      }
    }
    this.setState({});
  };
  handleCheckboxTop = () => {
    let data = [];
    if (
      this.state.category1ArryList?.length !=
        this.state.category1List?.length &&
      this.state.category1ArryList?.length > 0 &&
      this.state.category1List?.length > 0
    ) {
      this.state.category1List?.map((r) => data.push(r.category1Id));
    }

    if (
      this.state.category1ArryList?.length == 0 &&
      this.state.category1List?.length > 0
    ) {
      this.state.category1List?.map((r) => data.push(r.category1Id));
    }

    if (
      this.state.category1ArryList?.length ==
        this.state.category1List?.length &&
      this.state.category1List?.length > 0
    ) {
      data = [];
    }
    this.state.category1ArryList = data;
    this.setState({});
  };
  handleChangeChecked = (x) => {
    const { category1ArryList } = this.state;
    if (category1ArryList?.length == 0) {
      category1ArryList.push(x);
    } else {
      if (
        category1ArryList &&
        category1ArryList?.filter((i) => i == x)?.length == 1
      ) {
        category1ArryList?.map((i, ind) =>
          i == x ? category1ArryList.splice(ind, 1) : ""
        );
      } else {
        category1ArryList.push(x);
      }
    }
    this.setState({});
  };
  GetCategoryValue = (isview, id) => {
    var ids = this.state.category1ArryList;
    var CategoryId = parseInt(id) || parseInt(ids.toString());
    this.setState({ isCategory1Loader: true, isCategory1Failed: false });
    let apiUrl = `${API.GET_PARDICULAR_RECORD}?categoryId=${CategoryId}`;
    axios({
      method: "GET",
      url: apiUrl,
    })
      .then((res) => {
        if (res.status === 200) {
          const GetData = {
            categoryName: res.data.categoryName,
            categoryId: res.data.categoryId,
            isSubCategory: res.data.isSubCategory,
            historyLog: res.data?.historyLog || [],
          };
          this.state.editcategoryValue = GetData;
          this.setState({});
        }
        const newLocal = "editCategory1Screen";
        let myOffcanvas = new window.bootstrap.Offcanvas(
          document.getElementById(newLocal)
        );
        myOffcanvas.show();
        $("body").addClass("scrollhide");
        this.setState({
          isCategory1Loader: false,
          isCategory1Failed: false,
          isView: isview,
        });
      })
      .catch((error) => {
        this.setState({
          isCategory1Loader: false,
          isCategory1Failed: false,
          isView: false,
        });
        logoutFunction(error?.response?.status);
      });
  };
  AddCategory() {
    const { addcategoryValue, userId } = this.state;
    let Categoryadd = [
      {
        categoryName: addcategoryValue.categoryName,
        isSubCategory: false,
        categoryId: 0,
        parentCategoryId: 0,
      },
    ];
    if (Categoryadd[0].categoryName !== "") {
      let apiurl1 = `${API.EXIST_CATEGORYNAME}?categoryname=${Categoryadd[0].categoryName}&type=category1`;
      this.setState({ isCategory1Loader: true, isCategory1Failed: false });
      axios({
        method: "GET",
        url: apiurl1,
      }).then((res) => {
        if (res.data === false) {
          let apiUrl = `${API.POST_MASTERDATA}?userId=${userId}`;
          this.setState({ isCategory1Loader: true, isCategory1Failed: false });
          axios({
            method: "POST",
            url: apiUrl,
            data: Categoryadd,
          })
            .then((res) => {
              if (res.status === 200) {
                this.ClearAddCategory1();
                this.GetCategory1List();
                toast.success("Category added successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
                // this.setState({
                //   isCategory1Loader: false,
                //   isCategory1Failed: false,
                // });
              }
            })
            .catch((error) => {
              this.setState({
                isCategory1Loader: false,
                isCategory1Failed: false,
              });
              logoutFunction(error?.response?.status);
            });
        } else {
          this.setState({ isCategory1Loader: false, isCategory1Failed: false });
          toast.error(
            "This category name is already given. Please give another name.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      });
    } else {
      this.state.categoryEmpty = true;
      this.setState({});
    }
  }
  UpdateCategory = () => {
    const { editcategoryValue, userId } = this.state;
    let Categoryedit = [
      {
        categoryName: editcategoryValue.categoryName,
        isSubCategory: false,
        categoryId: editcategoryValue.categoryId,
        parentCategoryId: 0,
      },
    ];
    if (Categoryedit[0].categoryName !== "") {
      let apiurl1 = `${API.EXIST_CATEGORYNAME}?categoryname=${Categoryedit[0].categoryName}&type=category1`;
      this.setState({ isCategory1Loader: true, isCategory1Failed: false });
      axios({
        method: "GET",
        url: apiurl1,
      }).then((res) => {
        if (res.data === false) {
          let apiUrl = `${API.PUT_MASTERDATA}?userId=${userId}`;
          this.setState({ isCategory1Loader: true, isCategory1Failed: false });
          axios({
            method: "PUT",
            url: apiUrl,
            data: Categoryedit,
          })
            .then((res) => {
              if (res.data === true) {
                this.clearCategory1Edit();
                toast.success("Category edited successfully", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                  progress: undefined,
                  theme: "colored",
                });
              }
            })
            .catch((error) => {
              this.setState({
                isCategory1Loader: false,
                isCategory1Failed: false,
              });
              logoutFunction(error?.response?.status);
            });
        } else {
          this.setState({ isCategory1Loader: false, isCategory1Failed: false });
          toast.error(
            "This category name is already given. Please give another category name.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      });
    } else if (Categoryedit[0].categoryName === "") {
      this.state.categoryEmpty = true;
      this.setState({});
    }
  };
  OpenRemoveCategory1 = () => {
    var ids = this.state.category1ArryList;
    let apiurl1 = `${API.IS_DOCUMENT_PRESENT_CAT}?type=category1`;
    this.setState({ isCategory1Loader: true, isCategory1Failed: false });
    axios({
      method: "POST",
      url: apiurl1,
      data: ids,
    })
      .then((res) => {
        if (res.data?.length === 0) {
          this.setState({ isCategory1Loader: false, isCategory1Failed: false });
          let cancelPopup = new window.bootstrap.Modal(
            document.getElementById("RemoveCategory1Screen")
          );
          cancelPopup.show();
          $("body").addClass("scrollhide");
        } else {
          this.setState({ isCategory1Loader: false, isCategory1Failed: false });
          toast.error(
            "Sorry you cannot delete the catagory when documents exist in it.",
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            }
          );
        }
      })
      .catch((error) => {
        this.setState({ isCategory1Loader: false, isCategory1Failed: false });
        logoutFunction(error?.response?.status);
      });
  };
  cancelDeletePopup = () => {
    $("body").removeClass("scrollhide");
  };
  DeleteCategory = () => {
    const { editcategoryValue, userId, category1ArryList } = this.state;
    this.setState({ isCategory1Loader: true, isCategory1Failed: false });
    let apiUrl = `${API.DELETE_MASTERDATA}?userId=${userId}`;
    axios({
      method: "DELETE",
      url: apiUrl,
      data: category1ArryList,
    })
      .then((res) => {
        if (res.status === 200) {
          this.clearDeletedArray();
          this.GetCategory1List();
          toast.success("Category deleted successfully", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
          this.setState({ isCategory1Loader: false, isCategory1Failed: false });
        }
      })
      .catch((error) => {
        this.setState({ isCategory1Loader: false, isCategory1Failed: false });
        logoutFunction(error?.response?.status);
      });
  };
  ClearAddCategory1 = () => {
    this.state.categoryEmpty = false;
    let data = {
      categoryName: "",
      isSubCategory: false,
      categoryId: 0,
    };
    this.state.addcategoryValue = data;
    this.setState({});
    $("#addCategory1Screen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
  };
  clearCategory1Edit = () => {
    this.state.categoryEmpty = false;
    this.state.category1ArryList = [];
    this.setState({});
    $("#editCategory1Screen").removeClass("show");
    $(".offcanvas-backdrop").removeClass("show");
    $("body").removeClass("scrollhide");
    this.GetCategory1List();
  };
  clearDeletedArray = () => {
    $("body").removeClass("scrollhide");
    this.state.category1ArryList = [];
    this.setState({});
  };
  sortTable = (name) => {
    if (this.state.category1List?.length !== 0) {
      if (this.state.sortBy === name) {
        this.state.sortBy = name;
        if (this.state.order === "asc") {
          var ordernew = "desc";
          this.state.order = ordernew;
        } else {
          var ordernew = "asc";
          this.state.order = ordernew;
        }
      } else {
        this.state.sortBy = name;
        this.state.order = "asc";
      }
      this.state.currentPage = 1;
      this.setState({}, () => {
        this.GetCategory1List();
      });
    }
  };

  /*   sortTable = (name) => {
  let sortData =this.state.category1List; // Create a copy of the table data
  if(sortData?.length !==0 ){
  this.state.sortBy=name;
  this.setState({})
    if(this.state.sortBy === name) {
    if(this.state.order === "asc"){ 
       var ordernew = "desc"
       this.state.order=ordernew;
       this.setState({})
      }
      else { 
        var ordernew = "asc"
        this.state.order=ordernew;
        this.setState({})
      }
  
    }
  sortData.sort((a, b) => {
    let valueA = a[name];
    let valueB = b[name];
    if (name === "assignedDate" || name === "publishedDate"||name==="reviewDate"||name==="requestedDate")  {
        let dateA = new Date(a[name]); 
        let dateB = new Date(b[name]);
    
        if (this.state.order === 'asc') {
          return dateA.getTime() - dateB.getTime();
        } else {
          return dateB.getTime() - dateA.getTime();
        }
      }
        else if (typeof valueA === 'number' && typeof valueB === 'number') {
        // Numeric sorting
        if (this.state.order === 'asc') {
          return valueA - valueB;
        } else {
          return valueB - valueA;
       }
  
      } else {
          if (this.state.order === 'asc') {
            return (valueA ??" ").localeCompare(valueB? valueB:"");
          } else {
            return (valueB ??" ").localeCompare(valueA? valueA:"");
          }
        }
    });
    this.state.category1List=sortData;
    this.setState({}) 
  }
  }; */
  OpenPendingSearch = () => {
    this.GetDropdownCategory1();
    let myOffcanvas = new window.bootstrap.Offcanvas(
      document.getElementById("pendingSearchScreen")
    );
    myOffcanvas.show();
    $("body").addClass("scrollhide");
    const viewbar = document.getElementById("viewbar8");
    viewbar?.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    this.setState({ isFormValid: true });
  };

  handleSearchSelectChange = (value, field) => {
    //SelectedValueSearch = true;
    if (field === "category1") {
      if (value) {
        this.state.searchInputCategory = value;
        this.setState({});
      } else {
        this.state.searchInputCategory = "";
        this.setState({});
      }
    }
  };

  validatesubmitSearch = () => {
    var category1Input = this.state.searchInputCategory ? true : false;
    if (category1Input) {
      this.submitSearch();
    } else {
      this.setState({ isFormValid: false });
    }
  };

  submitSearch = () => {
    const { currentPage, perPage, userId } = this.state;
    this.setState({
      isCategory1Loader: true,
      isCategory1Failed: false,
      isFormValid: true,
    });
    let order = this.state.order === "asc" ? true : false;
    var searchDetails;

    if (closeNewSearch) {
      searchDetails = {
        pageNumber: 1,
        pagesize: parseInt(perPage),
        category1Id: 0,
        category1Name: null,
      };
    } else {
      searchDetails = {
        pageNumber: 1,
        pagesize: parseInt(perPage),
        category1Id: this.state.searchInputCategory
          ? this.state.searchInputCategory.value
          : 0,
        category1Name: this.state.searchInputCategory
          ? this.state.searchInputCategory.label
          : null,
      };
    }

    let apiUrl = `${API.GET_CATAGORY2}?category1Id=0&sortBy=${this.state.sortBy}&isSortAscending=${order}`;
    axios({
      method: "POST",
      url: apiUrl,
      data: searchDetails,
    })
      .then((res) => {
        if (res.status === 200) {
          this.state.category1List = res.data.values;
          this.state.totalCount = res.data.totalCount;
          this.state.isCategory1Loader = false;
          this.state.isCategory1Failed = false;
          closeNewSearch = false;
          this.setState({}, () => {
            this.closeSearch();
          });
          //this.setState({ isCategory1Loader: false, isCategory1Failed: false });
        }
      })
      // .catch((error) => {
      //
      //   this.setState({ isCategory1Loader: false, isCategory1Failed: false });
      //   logoutFunction(error?.response?.status);
      // });
      .catch((error) => {
        if (error.response.status === 400 || error.response.status === 500) {
          toast.error("Failed to search. Please try again", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
            progress: undefined,
            theme: "colored",
          });
        }
        this.setState({ isRequestLoader: false, isRequestFailed: false });
        logoutFunction(error?.response?.status);
      });
  };

  closeSearch = () => {
    // $("#pendingSearchScreen").removeClass("show");
    document.getElementById("closeSearchButton").click();
    $("body").removeClass("scrollhide");
  };

  clearSearch = () => {
    this.state.searchInputCategory = "";

    closeNewSearch = true;
    this.submitSearch();
  };

  render() {
    const {
      isCategory1Failed,
      isCategory1Loader,
      isMobile,
      isRadioMobile,
      isSmallMobile,
      category1ArryList,
      category1List,
      addcategoryValue,
      currentPage,
      isCategory1EditHide,
      isCategory1AddHide,
      isCategory1DeleteHide,
      perPage,
      editcategoryValue,
      order,
      sortBy,
      isFormValid,
      searchCategory1List,
    } = this.state;
    let { classes, category1CommonSearchResult, menuToggle } = this.props;
    return (
      <>
        {$("#addCategory1Screen").hasClass("show") ? (
          <div className="viewbar-overlay"></div>
        ) : $("#editCategory1Screen").hasClass("show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>
        )}
        <div className={`${isMobile ? "main-body-mobile" : "main-body"}`}>
          {isCategory1Loader && (
            <div className="spinner_overlay">
              <div className="loader">
                <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
              </div>
            </div>
          )}

          {isCategory1Failed && (
            <div className="spinner_overlay">
              <div className="loader">
                <span>Loading failed</span>
              </div>
            </div>
          )}
          {isMobile == true ? (
            <div className="head-fixed">
              <div className="mobile-head border-bottom w-100">
                <div
                  className="col-12 mobile-title"
                  style={{ paddingLeft: "2px" }}
                >
                  Category 1
                </div>
              </div>
              <div
                className={`${
                  isMobile ? "common-mobilesubmenu" : "common-submenu"
                }`}
              >
                <div
                  className={`col-12  ${isMobile ? "pl-1 pr-0" : "pl-10"}`}
                  // className=`col-11 d-flex justify-content-start``
                >
                  <button
                    className={`displaybutton ${isRadioMobile ? "pr-5" : ""} ${
                      isSmallMobile ? "pl-5" : ""
                    }`}
                    id="displaybuttoncolor"
                    onClick={() => this.OpenAddcategory1()}
                  >
                    <img src={AddIcon} />
                    <span className={`subhead-span p-2`}>Add</span>
                  </button>
                  {category1ArryList?.length === 1 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }  ${isSmallMobile ? "pl-5" : ""}`}
                        id="displaybuttoncolor"
                        onClick={() => this.GetCategoryValue(false)}
                      >
                        <img src={EditIcon} />
                        <span className={`subhead-span p-2`}>Edit</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  {category1ArryList?.length !== 0 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }  ${isSmallMobile ? "pl-5" : ""}`}
                        id="displaybuttoncolor"
                        onClick={() => this.OpenRemoveCategory1()}
                      >
                        <img src={RemoveIcon} />
                        <span className={`subhead-span p-2`}>Remove</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  <button
                    className="displaybutton"
                    id="displaybuttoncolor"
                    style={{ float: "inline-end" }}
                    onClick={() => this.OpenPendingSearch()}
                  >
                    <img
                      src={Filter}
                      // style={{ marginTop: "-4px", float: "right" }}
                    ></img>
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="head-fixed">
              <div className="title">
                <img src={CategoryIcon} />
                <span className="pl-10 head-span mt-10">Category 1</span>
              </div>
              <div
                className={`${
                  isMobile ? "common-mobilesubmenu" : "common-submenu"
                }`}
              >
                {/* <div className="row"> */}
                <div
                  className={`col-9   ${isMobile ? "pl-1 pr-0" : ""}`}
                  style={{ width: "80%" }}
                  // className=`col-9 d-flex justify-content-start``
                >
                  <button
                    className={`displaybutton ${isRadioMobile ? "pr-5" : ""} ${
                      isSmallMobile ? "pl-5" : ""
                    }`}
                    id="displaybuttoncolor"
                    onClick={() => this.OpenAddcategory1()}
                  >
                    <img src={AddIcon} />
                    <span className={`subhead-span p-2`}>Add</span>
                  </button>
                  {category1ArryList?.length === 1 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }  ${isSmallMobile ? "pl-5" : ""}`}
                        id="displaybuttoncolor"
                        onClick={() => this.GetCategoryValue(false)}
                      >
                        <img src={EditIcon} />
                        <span className={`subhead-span p-2`}>Edit</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  {category1ArryList?.length !== 0 ? (
                    <>
                      <button
                        className={`displaybutton ${
                          isRadioMobile ? "pr-5" : ""
                        }  ${isSmallMobile ? "pl-5" : ""}`}
                        id="displaybuttoncolor"
                        onClick={() => this.OpenRemoveCategory1()}
                      >
                        <img src={RemoveIcon} />
                        <span className={`subhead-span p-2`}>Remove</span>
                      </button>
                    </>
                  ) : (
                    <></>
                  )}
                  <button
                    className="displaybutton  ps-1"
                    id="displaybuttoncolor"
                    onClick={() => this.OpenPendingSearch()}
                    style={{ float: "inline-end" }}
                  >
                    <img
                      src={Filter}
                      // style={{ marginTop: "-4px", float: "right" }}
                    ></img>
                  </button>
                </div>
              </div>
            </div>
          )}
          <ToastContainer limit={1} />
          <div
            className={`${
              isMobile ? "favorite-mobile-table1 " : "favorite-table1 "
            } table-responsive  table-fixed-header table-responsive-height`}
            style={{ width: "100%" }}
          >
            <table className="table fileListTable2 table-borderless table-hover">
              <thead className="thead-sticky  thead-color">
                <tr>
                  <td className="wid-7">
                    <input
                      type="checkbox"
                      name="request"
                      checked={
                        category1ArryList?.length !== 0
                          ? category1ArryList?.length == category1List?.length
                            ? true
                            : false
                          : false
                      }
                      onClick={() => this.handleCheckboxTop()}
                    />
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => this.sortTable("category1Name")}
                  >
                    <span>Categories</span>
                    {sortBy === "category1Name" && (
                      <img src={order === "asc" ? upArrow : downArrow} alt="" />
                    )}{" "}
                  </td>
                  <td></td>
                </tr>
              </thead>
              <tbody>
                {category1List?.length !== 0 ? (
                  category1List?.map((item, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor:
                          category1ArryList?.filter(
                            (r) => r == item.category1Id
                          )?.length > 0
                            ? "#f3f2f1"
                            : "",
                      }}
                      onDoubleClick={() =>
                        this.handleChangeChecked(item.category1Id)
                      }
                    >
                      <td>
                        <input
                          type="checkbox"
                          name="request"
                          className="checkboxes t-input"
                          checked={
                            category1ArryList?.filter(
                              (r) => r == item.category1Id
                            )?.length > 0
                              ? true
                              : false
                          }
                          onClick={() => this.handleCheckbox(item.category1Id)}
                        />
                      </td>
                      <td>
                        <span
                          className="tablefilename"
                          onClick={() =>
                            this.GetCategoryValue(true, item.category1Id)
                          }
                          /* style={{textDecoration:"none"}} */ title={
                            item.category1Name
                          }
                        >
                          {item.category1Name}{" "}
                        </span>
                      </td>
                      <td></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="table-nodata">
                      {category1List && "No record found"}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div
            className={`${
              isMobile
                ? "common-mobilesubmenu mobile-pagination"
                : menuToggle
                ? "common-submenu sidemenu-pagination"
                : "common-submenu web-pagination"
            } pb-2 pt-2`}
          >
            {category1List?.length !== 0 ? (
              <table width="100%">
                <tbody>
                  <tr>
                    <td width="8%" className="p-3">
                      <div
                        className={`${
                          this.state.iswebMobile
                            ? "mobilePageSelect"
                            : "webpageSelect"
                        }`}
                      >
                        <Select
                          options={paginglist}
                          defaultValue={paginglistDefault}
                          classNamePrefix="paging"
                          isSearchable={false}
                          menuPlacement={"top"}
                          menuPosition={"fixed"}
                          onChange={(e) => this.find(e)}
                        />
                      </div>
                    </td>
                    <td
                      width="92%"
                      className={`text-end ${
                        this.state.isCancelMobile ? "pagination-padd" : "p-3"
                      }`}
                    >
                      {this.state.isMobile ? (
                        <Pagination
                          prevPageText={
                            <>
                              {" "}
                              <img src={LeftArrowIcon} />
                            </>
                          }
                          nextPageText={
                            <>
                              <img src={RightArrowIcon} />{" "}
                            </>
                          }
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item`}
                          linkClass="page-link"
                          pageRangeDisplayed={1}
                          onChange={this.handlePageChange}
                          activePage={this.state.currentPage}
                          totalItemsCount={this.state.totalCount}
                          itemsCountPerPage={this.state.perPage}
                        />
                      ) : (
                        <Pagination
                          prevPageText={
                            <>
                              {" "}
                              <img src={LeftArrowIcon} />
                            </>
                          }
                          nextPageText={
                            <>
                              <img src={RightArrowIcon} />{" "}
                            </>
                          }
                          linkClassNext="nextArrow"
                          linkClassPrev="prevArrow"
                          itemClass={`page-item`}
                          linkClass="page-link"
                          pageRangeDisplayed={3}
                          onChange={this.handlePageChange}
                          activePage={this.state.currentPage}
                          totalItemsCount={this.state.totalCount}
                          itemsCountPerPage={this.state.perPage}
                        />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            ) : null}
          </div>
        </div>
        <div
          className="offcanvas offcanvas-end offcanvasStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="addCategory1Screen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-3"
            }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title">
              Add category
            </h6>
            <button
              className={`text-reset offcavasclose buttonstyle pr-0`} //${ isMobile ? "pr-0" : ""}
              onClick={() => this.ClearAddCategory1()}
              style={{ backgroundColor: "white" }}
            >
              <img
                src={CrossIcon}
                className="cursor-pointer app-image-hover mb-1"
                height={15}
              />
            </button>{" "}
          </div>
          <div className="offcanvas-body px-4 ">
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}
              >
                <div className="form-group">
                  <label
                    className={`label-text  ${
                      isMobile
                        ? "d-flex pt-2 mb-2-ledger"
                        : "d-flex mb-2-ledger mb-1"
                    }`}
                  >
                    <img
                      className="properties-search-img"
                      src={SubCategoryIcon}
                    />{" "}
                    <span className="pl-10 properties-search-span">
                      Category 1 <span class="required-color">*</span>
                    </span>
                  </label>
                  <input
                    onChange={(e) =>
                      this.handlecategoryInputchange(e, "categoryName", "Add")
                    }
                    className="form-control border-radius shiptype-select mt-2"
                    value={addcategoryValue.categoryName}
                    maxLength={250}
                    style={{
                      fontSize: "12px",
                      height: "33px",
                      borderColor:
                        this.state.categoryEmpty === true ? "#d12232" : "",
                    }}
                  />
                  {this.state.categoryEmpty === true ? (
                    <span className="send-rework-label">
                      This field is required
                    </span>
                  ) : (
                    <></>
                  )}
                </div>{" "}
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
              <button
                className={`btn btn-light input-group f-size-13 d-flex offcavasclose  ${
                  isMobile ? "filter-nextMobilebtn ledgerbtn" : "filter-nextbtn"
                } p-2`}
                data-bs-dismiss={this.state.isCategory1AddHide && "offcanvas"}
                aria-label="Close"
                onClick={() => this.AddCategory()}
              >
                <img src={ButtonSubmitIcon} className="modal-img"></img>
                <span style={{marginTop:"1px"}} className="model-label pl-10 obsoletebtn">Submit</span>
              </button>
            </div>
          </div>
        </div>
        <div
          className={`offcanvas offcanvas-end offcanvasStyle ${
            this.state.isView ? "audit-offcanvas" : ""
          }`}
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="editCategory1Screen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-2"
            }`}
          >
            <h5 id="offcanvasRightLabel" className="modal-title">
              {this.state.isView ? "Category" : "Edit category"}
            </h5>
            <button
              className={`text-reset offcavasclose buttonstyle pr-0`} //  ${isMobile ? "pr-0" : ""}
              onClick={() => this.clearCategory1Edit()}
              style={{ backgroundColor: "white" }}
            >
              <img
                src={CrossIcon}
                className="cursor-pointer app-image-hover mb-1"
                height={15}
              />
            </button>{" "}
          </div>
          <div className="offcanvas-body px-4 pt-0">
            {this.state.isView && (
              <button
                className={`displaybutton p-0 ${isSmallMobile ? "pl-5" : ""}`}
                id="displaybuttoncolor"
                onClick={() =>
                  this.GetCategoryValue(false, editcategoryValue.categoryId)
                }
              >
                <img src={EditIcon} />
                <span className={`subhead-span p-2`}>Edit</span>
              </button>
            )}
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 mb-2`}
              >
                <div className="form-group">
                  <label
                    className={`label-text ${
                      isMobile
                        ? "d-flex pt-2 mb-2-ledger"
                        : "d-flex mb-2-ledger mb-1"
                    }`}
                  >
                    <img
                      className="properties-search-img"
                      src={SubCategoryIcon}
                    />{" "}
                    <span className="pl-10 properties-search-span">
                      Category 1
                    </span>
                  </label>
                  <input
                    onChange={(e) =>
                      this.handlecategoryInputchange(e, "categoryName", "Edit")
                    }
                    className="form-control border-radius shiptype-select mt-2"
                    value={editcategoryValue.categoryName}
                    disabled={this.state.isView}
                    maxLength={250}
                    style={{
                      fontSize: "12px",
                      height: "36px",
                      borderColor:
                        this.state.categoryEmpty === true ? "#d12232" : "",
                    }}
                  />
                </div>{" "}
              </div>
            </div>
            {!this.state.isView && (
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 mt-3 mb-1">
                <button
                  className={`btn btn-light input-group f-size-13 d-flex ${
                    isMobile ? "filter-nextMobilebtn ledgerbtn" : "filter-nextbtn"
                  } p-2`}
                  data-bs-dismiss={isCategory1EditHide && "offcanvas"}
                  onClick={() => this.UpdateCategory()}
                >
                  <img src={ButtonSubmitIcon} className="modal-img"></img>
                  <span style={{marginTop:"1px"}} className="model-label pl-10 obsoletebtn">Submit</span>
                </button>
              </div>
            )}
            {this.state.isView && editcategoryValue?.historyLog?.length > 0 && (
              <div>
                <div>
                  <h6 className="modal-title">Audit log</h6>
                </div>
                <div className="audit-table-wrapper audit-scroll-css">
                  <table className="px-3 audit-table">
                    <thead>
                      <tr className="border-bottom">
                        <th className="p-rem">Action</th>
                        <th className="p-rem">Action By</th>
                        <th className="p-rem wid-45">Description</th>
                        <th className="p-rem">Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {editcategoryValue?.historyLog.map((x) => (
                        <tr className="border-bottom">
                          <td className="p-rem">{x.action}</td>
                          <td className="p-rem">{x.actionBy}</td>
                          <td className="p-rem">{x.description}</td>
                          <td className="p-rem">
                            {moment
                              .utc(x.createdTime)
                              .local()
                              .format("DD-MMM-YYYY hh:mm A")}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Reomve Popup code */}
        <div
          className="modal fade modal-style"
          id="RemoveCategory1Screen"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="exampleModalCenterTitle"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered modal-lg"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header pb-2 pl-20">
                <h5 className="modal-title d-flex" id="exampleModalLongTitle">
                  <img src={WarningIcon} />
                  &nbsp;<span className="mt-1 pl-5"></span>Warning
                </h5>
              </div>
              <div className="modal-body pl-20">
                <h5 className="warning-text">
                  {" "}
                  Are you sure you want to remove the category ?
                </h5>
                <span className="app-label">
                  {" "}
                  All the subcategories will be deleted.
                </span>
              </div>
              <div className="modal-footer border-top-none justify-content-center pb-3">
                <button
                  className={`btn btn-light input-group  d-flex ${
                    isMobile ? "warning-btn-mobile p-1" : "warning-btn"
                  } `}
                  data-bs-dismiss="modal"
                  onClick={() => this.cancelDeletePopup()}
                >
                  <span className="rejectedstatus-color pl-10">No</span>{" "}
                </button>
                <button
                  className={`btn btn-light input-group d-flex ${
                    isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                  }`}
                  data-bs-dismiss="modal"
                  onClick={() => this.DeleteCategory()}
                >
                  <span style={{fontSize:"14px"}} className="model-label pl-10">Yes</span>{" "}
                </button>
              </div>
            </div>
          </div>
        </div>
        {/* Common search */}
        <div
          className="offcanvas offcanvas-end offcanvaspendingStyle"
          tabIndex={-1}
          data-bs-scroll="false"
          data-bs-backdrop="false"
          id="pendingSearchScreen"
          aria-labelledby="offcanvasScrollingLabel"
        >
          <div
            className={`offcanvas-header px-4 pt-4 ${
              isMobile ? "pb-2" : "pb-3"
            }`}
          >
            <h6 id="offcanvasRightLabel" className="modal-title">
              Search
            </h6>
            <button
              className={`text-reset offcavasclose  buttonstyle ${
                isMobile ? "pr-0" : "pr-0"
              }`}
              data-bs-dismiss="offcanvas"
              id="closeSearchButton"
              onClick={() => this.closeSearch()}
              style={{ backgroundColor: "white" }}
            >
              <img src={CrossIcon} className="cursor-pointer app-image-hover" />
            </button>{" "}
          </div>
          <div className="offcanvas-body px-4 " id="viewbar8">
            <div className="row">
              <div
                className={`col-12 col-sm-12 col-lg-12 col-xl-12 col-md-12 mt-2 `}
                // className="col-sm-6 col-12 mt-2 mb-2"
              >
                <div className="inputTitle mb-2 commonsearch-field">
                  <img src={SubCategoryIcon} alt="" />
                  <span> Category 1</span>
                </div>
                <Select
                  className="text-12-normal"
                  classNamePrefix="assigngroups"
                  value={this.state.searchInputCategory}
                  options={searchCategory1List}
                  defaultValue={this.state.searchInputCategory || "Select"}
                  isMulti={false}
                  isSearchable={true}
                  isClearable={true}
                  onChange={(value) =>
                    this.handleSearchSelectChange(value, "category1")
                  }
                />
              </div>
            </div>

            {!isFormValid && (
              <p style={{ color: "red" }}>At least one field is mandatory</p>
            )}

            <div className="button" style={{ display: "flex" }}>
              <button id="edit2" onClick={() => this.clearSearch()}>
                <span className="clear-icon-position">✕</span>
                <span>Clear</span>
              </button>
              <button id="edit" onClick={() => this.validatesubmitSearch()}>
                <img
                  style={{
                    marginRight: "4px",
                    width: "14px",
                  }}
                  src={search}
                  alt=""
                />
                Search
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

function mapStateToProps(state) {
  return {
    menuToggle: state.commonReducer.menuToggle,
    category1CommonSearchResult:
      state.commonReducer.category1CommonSearchResult,
    sideMenu: state.commonReducer.sideMenu,
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Category1)
);
